import { useCallback } from 'react';

import { IMAGE_STATUS } from '@ecp/common/src/const/imageFile';

import { useImageFileUploader } from '@bo-hooks/common/useImageFileUploader';

export const useSiteImage = ({ siteInfo, setForm, form, welmallInfo }) => {
  const { saveImageFile, deleteImageFile } = useImageFileUploader();

  const setFormFileInfo = useCallback(
    (useBasicYn, targetKey, targetList, basicUseYnKey) => {
      if (useBasicYn === 'Y') {
        setForm((prev) => ({
          ...prev,
          [targetKey]: targetList.map(({ key, type }) => ({
            fileId: welmallInfo[`${key}Id`],
            status: IMAGE_STATUS.REGISTERED,
            url: welmallInfo[`${key}Path`],
            type,
          })),
        }));
      } else {
        let fileList = [];
        if (siteInfo[basicUseYnKey] === 'N') {
          fileList = targetList.map(({ key, type }) => ({
            fileId: siteInfo[`${key}Id`],
            status: IMAGE_STATUS.REGISTERED,
            url: siteInfo[`${key}Path`],
            type,
          }));
        }

        setForm((prev) => ({
          ...prev,
          [targetKey]: fileList,
        }));
      }
    },
    [setForm, welmallInfo, siteInfo]
  );

  const setRequestImageInfo = async ({ requestData, useYnKey, fileIdKeyList, fileListKey }) => {
    if (form[useYnKey] === 'Y') {
      fileIdKeyList.forEach((fileIdKey) => {
        requestData[fileIdKey] = welmallInfo[fileIdKey];
      });
    } else {
      const fileUploaded = await saveImageFile({ imageFileParam: form[fileListKey] });
      fileUploaded
        .filter(({ status }) => ![IMAGE_STATUS.NEED_TO_DEL, IMAGE_STATUS.REGISTERED].includes(status))
        .forEach(({ type, fileId }) => {
          requestData[type] = fileId;
        });
      // 기본형 Y 인 경우. 웰몰 이미지가 삭제되는것을 방지
      if (siteInfo[useYnKey] === 'N') await deleteImageFile({ imageFileParam: form[fileListKey] });
    }
  };

  return {
    setRequestImageInfo,
    setFormFileInfo,
  };
};
